export default __webpack_public_path__ + "239af9df7a4671189cdef4c9f0c12ad4.png";